import { render, staticRenderFns } from "./ServicesInPartnership.vue?vue&type=template&id=098d476e"
import script from "./ServicesInPartnership.vue?vue&type=script&lang=js"
export * from "./ServicesInPartnership.vue?vue&type=script&lang=js"
import style0 from "./ServicesInPartnership.vue?vue&type=style&index=0&id=098d476e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports